const channelDictIT = {
  channelHeaderNote: "Negozi selezionati per ScontiPoste",
  channelCart: "Carrello",
  channelTicketTitle: "{percent}% di cashback ScontiPoste",
  channelTicketRule:
    "Paga con la tua carta Postepay o BancoPosta: il cashback te lo accredita Poste Italiane, di solito entro 5 giorni.",
  channelTicketWarning:
    "Con altre carte l'acquisto è valido, ma Poste Italiane non riconosce il cashback.",
  channelSearchPlaceholder: "Cerca un prodotto",
  channelSearch: "Cerca",
  channelAllCategories: "Tutto",
  channelNoProducts: "Nessun prodotto qui per ora. Prova un'altra categoria o un'altra ricerca.",
  channelLoadMore: "Mostra altri prodotti",
  channelFreeDelivery: "Spedizione gratuita",
  channelPickup: "Ritiro in negozio",
  channelSoldBy: "Venduto da {seller}",
  channelAddToCart: "Aggiungi al carrello",
  channelAdded: "Aggiunto al carrello",
  channelGoToCart: "Vai al carrello",
  channelQuantity: "Quantità",
  channelChooseOption: "Scegli {name}",
  channelChooseVariation: "Scegli una variante",
  channelOutOfStock: "Esaurito",
  channelPickupAt: "Ritiro presso: {address}",
  channelPickupDays: "Hai {days} giorni per ritirare.",
  channelBackToShop: "Torna ai prodotti",
  channelDescription: "Descrizione",
  channelCartTitle: "Il tuo carrello",
  channelCartEmpty: "Il carrello è vuoto.",
  channelCartEmptyAction: "Scopri i prodotti",
  channelShippedBy: "Spedito da {seller}",
  channelPickupFrom: "Ritiro presso {seller}",
  channelRemove: "Rimuovi",
  channelDecrease: "Diminuisci quantità",
  channelIncrease: "Aumenta quantità",
  channelShipping: "Spedizione",
  channelShippingFree: "Gratis",
  channelTotal: "Totale",
  channelPricesIncludeFees: "I prezzi includono i costi di servizio.",
  channelCheckoutCta: "Procedi all'acquisto",
  channelUnavailableItem: "Questo prodotto non è più disponibile: rimuovilo per continuare.",
  channelCheckoutTitle: "Completa l'acquisto",
  channelYourDetails: "I tuoi dati",
  channelFirstname: "Nome",
  channelSurname: "Cognome",
  channelEmail: "Email",
  channelEmailHelp: "Qui ti inviamo la conferma dell'ordine.",
  channelPhone: "Telefono (facoltativo)",
  channelDeliveryAddress: "Indirizzo di consegna",
  channelAddress: "Via o piazza",
  channelNumber: "Numero civico",
  channelPostalCode: "CAP",
  channelCity: "Città",
  channelProvince: "Provincia (sigla, es. RM)",
  channelItalyOnly: "Consegniamo solo in Italia.",
  channelPickupOnly: "Tutti i prodotti si ritirano in negozio: non serve un indirizzo.",
  channelPayment: "Pagamento",
  channelCardHelp: "Usa la tua carta Postepay o BancoPosta per ricevere il cashback.",
  channelCardName: "Nome sulla carta",
  channelCardNumber: "Numero della carta",
  channelCardExpiry: "Scadenza",
  channelCardCvv: "CVV",
  channelPay: "Paga {total}",
  channelFillRequired: "Compila i campi obbligatori.",
  channelInvalidEmail: "Inserisci un'email valida.",
  channelInvalidCard: "Controlla i dati della carta.",
  channelPaymentFailed: "Il pagamento non è andato a buon fine. Riprova o usa un'altra carta.",
  channelAccountNote:
    "Con l'acquisto creiamo per te un account Extraconomy gratuito, per seguire i tuoi ordini.",
  channelOrderSummary: "Riepilogo",
  channelThanksTitle: "Ordine confermato",
  channelThanksIntro: "Grazie! Abbiamo ricevuto il pagamento di {total}.",
  channelThanksOrders: "I tuoi ordini",
  channelOrderNumber: "Ordine n. {id}",
  channelThanksDelivery: "Il venditore spedisce il pacco all'indirizzo che hai indicato.",
  channelThanksPickup: "Ritiri il prodotto presso il venditore.",
  channelThanksNewAccount:
    "Abbiamo creato il tuo account Extraconomy con {email}. Apri l'email che ti abbiamo inviato e scegli una password per seguire i tuoi ordini.",
  channelThanksExistingAccount: "L'ordine è nel tuo account Extraconomy ({email}). Accedi per seguirlo.",
  channelLogin: "Accedi",
  channelThanksCashback:
    "Se hai pagato con Postepay o BancoPosta, Poste Italiane ti accredita il {percent}% di cashback, di solito entro 5 giorni.",
  channelContinueShopping: "Continua a comprare",
  channelThanksMissing:
    "I dettagli dell'ordine non sono più disponibili in questa pagina. Li trovi nell'email di conferma.",
  channelPasswordTitle: "Crea la tua password",
  channelPasswordIntro: "Con la password accedi al tuo account e segui i tuoi ordini.",
  channelPassword: "Password",
  channelPasswordConfirm: "Ripeti la password",
  channelPasswordHelp: "Almeno 8 caratteri.",
  channelPasswordMismatch: "Le password non coincidono.",
  channelPasswordSave: "Crea password e accedi",
  channelPasswordInvalidLink:
    "Il link non è valido o è scaduto. Per riceverne uno nuovo usa \"Password dimenticata\" nella pagina di accesso.",
  channelGoToLogin: "Vai all'accesso",
  channelProcessingTitle: "Stiamo confermando il pagamento",
  channelProcessingText: "Può volerci qualche secondo. Non chiudere e non ricaricare questa pagina.",
  channelInvalidItalianAddress: "Inserisci un CAP italiano di 5 cifre e la sigla della provincia (es. RM).",
  channelError500438: "Inserisci un CAP italiano di 5 cifre e la sigla della provincia (es. RM).",
  orderDetailsChannelCashbackBuyer: "Ordine ScontiPoste: il cashback non viene accreditato su Extraconomy. Se hai pagato con una carta Postepay o BancoPosta, te lo accredita Poste Italiane sulla carta, di solito entro 5 giorni.",
  orderDetailsChannelCashbackSeller: "Ordine ScontiPoste: questo cashback viene trattenuto dalla vendita e corrisposto al cliente da Poste Italiane, sulla sua carta.",
  channelLoading: "Caricamento",
  channelGenericError: "Qualcosa non ha funzionato. Riprova tra poco.",
  channelError500037: "Prodotto non trovato.",
  channelError500069: "Scegli una variante del prodotto.",
  channelError500074: "Uno dei prodotti è esaurito. Controlla il carrello.",
  channelError500417: "Questo negozio non esiste.",
  channelError500418: "Questo negozio non è disponibile in questo momento.",
  channelError500419: "Uno dei prodotti non è più disponibile. Controlla il carrello.",
  channelError500420: "Controlla le quantità nel carrello.",
  channelError500423: "I prezzi del carrello sono cambiati. Controlla il totale e riprova.",
  channelError500424: "La sessione di pagamento non è valida. Ricarica la pagina e riprova.",
  channelError500425:
    "Non abbiamo potuto confermare il pagamento. Se l'importo è stato addebitato, viene rimborsato.",
  channelError500426: "Inserisci l'indirizzo di consegna.",
  channelError500427: "Consegniamo solo in Italia.",
  channelError500428: "Inserisci nome, cognome e un'email valida.",
  channelError500429: "Non puoi acquistare i tuoi stessi prodotti.",
  channelError500430: "Non siamo riusciti a completare l'acquisto e il pagamento è stato rimborsato.",
  channelError500431:
    "Il link non è valido o è scaduto. Per riceverne uno nuovo usa \"Password dimenticata\" nella pagina di accesso.",
  channelError500432: "La password deve avere almeno 8 caratteri.",
  channelError500433: "Il carrello ha troppi prodotti.",
};

export default channelDictIT;
